var map = {
	"./icon-payment-abitab.png": "8a0d",
	"./icon-payment-bank - Copy.png": "e580",
	"./icon-payment-bank.png": "5fc5",
	"./icon-payment-cards - Copy.png": "8305",
	"./icon-payment-cards.png": "34f4",
	"./icon-payment-debit.png": "26df",
	"./icon-payment-master.png": "96aa",
	"./icon-payment-oca.png": "d37e",
	"./icon-payment-redpagos.png": "fddf",
	"./icon-payment-visa.png": "f55c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "954c";